import { notitficationActionTypes } from '../../constants';
import { NotificationType, Notification as NotificationInterface } from '../../types';

const addNotification = (message: string, notiType: NotificationType = 'INFO') => ({
  type: notitficationActionTypes.ADD_NOTIFICATION,
  payload: {
    id: Date.now() + Math.random(),
    message,
    notiType
  }
});

const removeNotification = (id: number) => ({
  type: notitficationActionTypes.REMOVE_NOTIFICATION,
  payload: {
    id
  }
});

export const notificationActions = {
  addNotification,
  removeNotification
};
